import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ReadonlyVersionInfoView } from './ReadonlyVersionInfoView';
import type { Firmware } from '../../types';
import type { EditableDropdownItem } from '@/components/EditableDropdown';

interface FirmwareActiveViewProps {
  firmware: Firmware;
  firmwareTypeItems: EditableDropdownItem[];
}

export function FirmwareActiveView({
  firmware,
  firmwareTypeItems,
}: FirmwareActiveViewProps) {
  const { t } = useTranslation();

  const resolvedType = useMemo(
    () => firmwareTypeItems.find((item) => item.id === firmware.firmwareTypeID)?.label || firmware.firmwareTypeID.toString(),
    [firmwareTypeItems, firmware.firmwareTypeID]
  );
  const resolvedCountry = useMemo(
    () => firmware.countryID === null ? t('firmware.filters.global') : firmware.countryID,
    [firmware.countryID, t]
  );

  return (
      <ReadonlyVersionInfoView
        versionString={firmware.versionString}
        resolvedType={resolvedType}
        resolvedCountry={resolvedCountry}
        fileUploaded={firmware.fileUploaded}
      />
  );
}
